export type BorderStyle = 'solid' | 'dashed' | 'dotted';

export interface ToolbarBorderStyle {
  borderWidth: number;
  borderStyle: BorderStyle;
}

export enum ExportMode {
  Diagram,
  Viewport,
}

export interface ToolbarShadow {
  blur: number;
  offset: { x: number; y: number };
  color: string;
}
